import { useReveal } from "@/hooks/useReveal";

const ITEMS = [
  {
    title: "Point-of-sale material",
    text: "Shelf talkers, small display units and recipe cards, produced to your market's language and format and shipped with the order.",
  },
  {
    title: "Full brand asset pack",
    text: "Product photography, lifestyle images, logo files, origin copy and social media assets, handed over on your first order. Yours to use without asking us each time.",
  },
  {
    title: "Staff and buyer training",
    text: "A short product session for your sales team and for the store staff who will actually have to answer the customer's question about what this is.",
  },
  {
    title: "Tasting samples",
    text: "Product for in-store tastings and for your own buyer presentations, at our cost, within an agreed quantity per launch.",
  },
  {
    title: "The origin story, documented",
    text: "Farm and cooperative material, traceability records and photographs. Not a marketing narrative — the actual documentation behind it.",
  },
  {
    title: "Direct access to the producer",
    text: "You deal with the general manager, not with an export agent. Questions about a batch, a specification or a delivery are answered by the person who can change them.",
  },
];

export default function WhatWeContribute() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="contribute" className="bg-ink py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal max-w-[800px]">
          <h2 className="text-cream font-serif text-3xl md:text-4xl font-semibold">
            What we put in, and what we do not
          </h2>
          <p className="mt-5 text-cream/70 text-[17px] md:text-lg leading-relaxed">
            Every distributor asks this in the first call, so here it is before
            you have to. We do not contribute cash. We are a small producer and
            we do not buy listings, fund advertising or pay slotting fees, and
            any supplier who tells you otherwise at our size is either much
            larger than us or about to disappoint you. What we do contribute is
            everything that is not money, and we contribute it properly.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-cream/15 p-7"
            >
              <h3 className="text-cream font-serif text-lg font-semibold">
                {item.title}
              </h3>
              <p className="mt-3 text-cream/70 text-[17px] leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-brand/50 p-6">
          <p className="text-cream/90 text-[17px] leading-relaxed text-center">
            If your model requires a cash marketing contribution from the
            supplier, we are not the right partner and we would rather say so
            now.
          </p>
        </div>
      </div>
    </section>
  );
}